import React, { useState } from 'react';
import Button from '../../ui/Button';

const BusinessSizeStep = ({ onNext, onBack, initialData = {} }) => {
  const [selectedSize, setSelectedSize] = useState(initialData.businessSize || '');

  const businessSizes = [
    {
      id: 'solo',
      label: 'Trabalho sozinho',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
      description: 'Você é o único profissional no seu negócio'
    },
    {
      id: 'small',
      label: '1 a 4 funcionários',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      description: 'Pequeno negócio com poucos profissionais'
    },
    {
      id: 'medium',
      label: '4 a 10 funcionários',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      description: 'Negócio de médio porte com equipe estabelecida'
    },
    {
      id: 'large',
      label: '10+ funcionários',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      description: 'Negócio grande com múltiplas equipes'
    },
    {
      id: 'franchise',
      label: 'Redes/franquia',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      description: 'Rede de estabelecimentos ou sistema de franquias'
    }
  ];

  const handleContinue = () => {
    if (selectedSize) {
      onNext({ businessSize: selectedSize });
    }
  };

  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl font-semibold text-center text-gray-800 mb-3">
        Qual o tamanho do seu negócio?
      </h2>
      <p className="text-gray-600 text-center mb-8">
        Isso nos ajudará a personalizar sua experiência
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        {businessSizes.map((size) => (
          <div
            key={size.id}
            onClick={() => setSelectedSize(size.id)}
            className={`border rounded-lg p-4 cursor-pointer transition-all transform hover:shadow-md hover:-translate-y-1 ${
              selectedSize === size.id
                ? 'border-blue-500 bg-blue-50 shadow-md'
                : 'border-gray-200 hover:border-blue-200'
            }`}
          >
            <div className="flex items-center">
              <div className={`p-2 rounded-full mr-3 ${
                selectedSize === size.id ? 'text-blue-600' : 'text-gray-500'
              }`}>
                {size.icon}
              </div>
              <div>
                <h3 className={`font-medium ${
                  selectedSize === size.id ? 'text-blue-700' : 'text-gray-700'
                }`}>
                  {size.label}
                </h3>
                <p className="text-sm text-gray-500">{size.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack}>
          Voltar
        </Button>
        <Button
          type="button"
          onClick={handleContinue}
          disabled={!selectedSize}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default BusinessSizeStep; 